// Copyright (c) 2017 Deere & Company

import './index.scss';
import * as ClaimSearchHelper from '../../shared/services/claim-search-helper';
import React, {
    Component,
    PropTypes
} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../shared/services/collections';
import {
    getAllAvailableColumns,
    getAvailableColumns
} from '../../../shared/services/available-excel-columns';
import {
    injectIntl,
    intlShape
} from 'react-intl';
import AccordionState from '../../../shared/components/smart-accordion/state/accordion';
import ClaimSearchFacets from './claim-search-facets';
import ClaimSearchHeader from './claim-search-header';
import ClaimSearchList from './claim-search-list';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import CreateClaimModal from '../../../shared/components/create-claim-modal';
import CreateClaimModalType from '../../../shared/state/create-claim-modal';
import ExcelLayoutModal from '../../../shared/components/excel-layout/excel-layout-modal';
import ExportToExcel from '../../../shared/state/export-to-excel';
import LaborRateLinkPanel from '../../shared/components/labor-rate-link-panel';
import RefinableListWidgetWithExportAndLayouts from '../../../shared/components/refinable-list-widget/refinable-list-widget-with-export-and-layouts';
import ReportLinks from '../../../shared/components/report-links';
import SearchBox from '../../../shared/components/search-box';
import SearchByDropDown from '../../shared/state/search-by-dropdown';
import SearchFilters from '../state/search-filters';
import State from '../state';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToExcel} from '../../../shared/services/export-to-excel';
import {getClaimsColumns} from '../../shared/services/claims-excel-columns';
import {getSortByList} from '../../../shared/services/get-excel-layout-modal-sort-by-list';

function handleCreateClaimModalClose() {

    this.actions.updateCreateClaimModalVisibility(false);

}

function handleColumnMove(dragIndex, hoverIndex, listId, dragCard) {

    listId === 'available-items' ?
        this.actions.updateExcelLayoutModalAvailableColumnsOrder(dragIndex, hoverIndex, dragCard) :
        this.actions.updateExcelLayoutModalExcelLayoutColumnsOrder(dragIndex, hoverIndex, dragCard);

}

function handleColumnPush(column, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.pushExcelLayoutModalExcelLayoutColumn(column) :
        this.actions.pushExcelLayoutModalAvailableColumn(column);

}

function handleColumnRemove(index, sourceListId) {

    sourceListId === 'available-items' ?
        this.actions.removeExcelLayoutModalAvailableColumn(index) :
        this.actions.removeExcelLayoutModalExcelLayoutColumn(index);

}

function handleExcelLayoutDelete() {

    this.actions.deleteExcelLayout(this.exportToExcel.selectedExcelLayout.claims.name, this.exportToExcel.selectedExcelLayout.claims.listId, 'claims');

}

function handleLayoutNameBlur(layoutName) {

    const nameAlreadyExists = this.exportToExcel.excelLayouts.claims.some(layout => layout.name === layoutName);

    nameAlreadyExists ?
        this.actions.updateExcelLayoutModalIsNameValid(false) :
        this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleLayoutNameChange(layoutName) {

    this.actions.updateExcelLayoutModalLayoutName(layoutName);

}

function handleExcelLayoutModalClose() {

    this.actions.updateExcelLayoutModalVisibility(false);
    this.actions.updateExcelLayoutModalIsNameValid(true);

}

function handleSaveExcelLayout() {

    this.actions.saveExcelLayout(this.exportToExcel.excelLayoutModal.excelLayout, 'claims');

}

function handleSetAsDefaultChange(isSelected) {

    this.actions.updateExcelLayoutModalExcelLayoutIsDefault(isSelected);

}

function handleSortByChange(sortByColumn) {

    this.actions.updateExcelLayoutModalExcelLayoutSortBy(sortByColumn, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateExcelLayoutModalExcelLayoutSortDirection(sortDirection, this.exportToExcel.excelLayoutModal.excelLayout.sortBy);

}

function handleSearch(query) {

    this.actions.onSearch(this.searchByDropDown.selectedOption.key, query);

}

function handleClick(key, pin) {

    this.actions.onCreateClaim(key, pin);

}

function handleReportsAccordionToggle() {

    this.actions.toggleReportsAccordion();

}

function handleCreateExcelLayout() {

    const availableColumns = getAllAvailableColumns('claims');

    this.actions.updateExcelLayoutModalExcelLayout(true);
    this.actions.updateExcelLayoutModalIsNewLayout(true, 'claims');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

    if (!this.exportToExcel.excelLayouts.claims.length) {

        this.actions.updateExcelLayoutModalExcelLayoutIsDefault(true);

    }

    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleEditExcelLayout() {

    const availableColumns = getAvailableColumns('claims', this.exportToExcel.selectedExcelLayout.claims.columns);

    this.actions.updateExcelLayoutModalExcelLayout(false, this.exportToExcel.selectedExcelLayout.claims);
    this.actions.updateExcelLayoutModalIsNewLayout(false, 'claims');
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);
    this.actions.updateExcelLayoutModalVisibility(true);

}

function handleExcelLayoutChange(selectedLayout) {

    const availableColumns = getAvailableColumns('claims', selectedLayout.columns);

    this.actions.updateSelectedExcelLayout(selectedLayout, 'claims');
    this.actions.updateExcelLayoutModalExcelLayout(false, selectedLayout);
    this.actions.updateExcelLayoutModalAvailableColumns(availableColumns);

}

class ClaimSearch extends Component {

    componentWillMount() {

        this.props.actions.readClaimTypes();

        if (this.props.queryParams.q && this.props.queryParams.by) {

            this.props.actions.updateSearchQueryString(this.props.queryParams.q);
            this.props.actions.updateSearchByDropDown(this.props.queryParams.by);
            this.props.actions.updateSearchResults(this.props.queryParams.q, this.props.queryParams.by);

        }

    }

    componentWillReceiveProps(nextProps) {

        const newSearch = (nextProps.queryParams.by && nextProps.queryParams.q) && (this.props.queryParams.by !== nextProps.queryParams.by || this.props.queryParams.q !== nextProps.queryParams.q);

        if (newSearch) {

            this.props.actions.updateSearchQueryString(nextProps.queryParams.q);
            this.props.actions.updateSearchByDropDown(nextProps.queryParams.by);
            this.props.actions.updateSearchResults(nextProps.queryParams.q, nextProps.queryParams.by);

        }

    }

    componentWillUnmount() {

        this.props.actions.updateCreateClaimModalVisibility(false);
        this.props.actions.resetExportToExcelLayout();

    }

    render() {

        let sortedCollection;

        sortedCollection = [...this.props.filteredSearchResults];
        sortedCollection = sortCollection(this.props.searchFilters.sortBy, this.props.searchFilters.sortDirection, sortedCollection);
        sortedCollection = filterCollection(this.props.searchFilters.filterBy, ClaimSearchHelper.getFilterOptions(), sortedCollection);

        return (
            <section className='claim-search'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <aside className='aside-container'>
                    <ClaimSearchFacets
                        queryParams={this.props.queryParams}
                    />
                    <LaborRateLinkPanel/>
                    <div className='report-links'>
                        <ReportLinks
                            accordion={this.props.reportsAccordion}
                            onAccordionToggle={this.props::handleReportsAccordionToggle}
                            parentRoute='claims'
                            routes={this.props.reportsRoutes}
                        />
                    </div>
                </aside>
                <main className='claim-search-main'>
                    <SearchBox
                        defaultOption={this.props.searchByDropDown.selectedOption.key}
                        onOptionChange={this.props.actions.updateSearchByDropDown}
                        onQueryChange={this.props.actions.updateSearchQueryString}
                        onSearch={this.props::handleSearch}
                        placeholderText={ClaimSearchHelper.mapSearchPlaceHolder(this.props.searchByDropDown.selectedOption.key)}
                        queryString={this.props.searchQueryString}
                        searchBy={this.props.searchByDropDown.searchBy}
                    />
                    <ClaimSearchHeader
                        allClaimsCount={this.props.allClaimsCount}
                        claimSearchCount={this.props.filteredSearchResults.length}
                        dealerInvoiceCount={this.props.dealerInvoiceCount}
                    />
                    <section className='claim-search-results-container'>
                        <RefinableListWidgetWithExportAndLayouts
                            excelLayouts={this.props.exportToExcel.excelLayouts.claims}
                            hasResults={this.props.filteredSearchResults.length > 0}
                            onCreateLayout={this.props::handleCreateExcelLayout}
                            onEditLayout={this.props::handleEditExcelLayout}
                            onExport={() => exportToExcel(`/api/claims/search?by=${this.props.searchByDropDown.selectedOption.key}&q=${encodeURIComponent(this.props.searchQueryString)}&export=EXCEL&language=${this.context.user.getLocale()}&layout=${encodeURIComponent(this.props.exportToExcel.selectedExcelLayout.claims.name)}&listId=$claims`)}
                            onFilterByChange={this.props.actions.updateListFilterBy}
                            onLayoutChange={this.props::handleExcelLayoutChange}
                            onSortByChange={this.props.actions.updateListSortBy}
                            onSortDirectionChange={this.props.actions.updateListSortDirection}
                            searchFilters={this.props.searchFilters}
                            selectedLayout={this.props.exportToExcel.selectedExcelLayout.claims}
                            sortOptions={ClaimSearchHelper.getSortOptions()}
                            type={State}
                        />
                        <ClaimSearchList
                            actions={this.props.actions}
                            busyCounter={this.props.busyCounter}
                            claims={sortedCollection}
                            isEditable={this.props.isEditable}
                        />
                    </section>
                    <CreateClaimModal
                        claimTypes={this.props.createClaimModal.claimTypes}
                        isModalOpen={this.props.createClaimModal.isModalOpen}
                        onClick={this.props::handleClick}
                        onCloseButtonClick={this.props::handleCreateClaimModalClose}
                        selectedPin={this.props.createClaimModal.selectedPin}
                    />
                    <ExcelLayoutModal
                        excelLayoutModal={this.props.exportToExcel.excelLayoutModal}
                        mappingTable={getClaimsColumns().listColumns}
                        onColumnMove={this.props::handleColumnMove}
                        onColumnPush={this.props::handleColumnPush}
                        onColumnRemove={this.props::handleColumnRemove}
                        onLayoutDelete={this.props::handleExcelLayoutDelete}
                        onLayoutNameBlur={this.props::handleLayoutNameBlur}
                        onLayoutNameChange={this.props::handleLayoutNameChange}
                        onModalClose={this.props::handleExcelLayoutModalClose}
                        onSaveLayout={this.props::handleSaveExcelLayout}
                        onSetAsDefaultChange={this.props::handleSetAsDefaultChange}
                        onSortByChange={this.props::handleSortByChange}
                        onSortDirectionChange={this.props::handleSortDirectionChange}
                        sortByList={getSortByList(getClaimsColumns().listColumns, this.props.exportToExcel.excelLayoutModal.excelLayout.columns)}
                    />
                </main>
            </section>
        );

    }

}

ClaimSearch.displayName = 'ClaimSearch';
ClaimSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    allClaimsCount: PropTypes.number.isRequired,
    busyCounter: PropTypes.number.isRequired,
    createClaimModal: PropTypes.instanceOf(CreateClaimModalType).isRequired,
    dealerInvoiceCount: PropTypes.number.isRequired,
    exportToExcel: PropTypes.instanceOf(ExportToExcel).isRequired,
    filteredSearchResults: PropTypes.arrayOf(PropTypes.instanceOf(ClaimSearchResult)).isRequired,
    intl: intlShape.isRequired,
    isEditable: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired,
    reportsAccordion: PropTypes.instanceOf(AccordionState).isRequired,
    reportsRoutes: PropTypes.object.isRequired,
    searchByDropDown: PropTypes.instanceOf(SearchByDropDown).isRequired,
    searchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    searchQueryString: PropTypes.string.isRequired
};
ClaimSearch.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default injectIntl(ClaimSearch);



// WEBPACK FOOTER //
// ./src/claim/claim-search/components/index.js